import React from 'react';
import Button from 'jbc-front/components/Button';
import { FormSubmitBtn } from 'src/buttons';
import CommonModal from 'jbc-front/components/CommonModal';

const PdfCreateModal = props => {
  const { isOpen, hideModal, submitting, createClick } = props;
  const header = '賃金台帳一括作成';

  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <React.Fragment>
        <CommonModal.Header hideModal={hideModal}>{header}</CommonModal.Header>
        <CommonModal.Body>
          <form>
            <p>
              賃金台帳を一括でダウンロード、印刷するためのデータを作成します。
              <br />
              <br />
              作成するデータ量により時間がかかる場合があります。
              <br />
              問題がなければ作成するボタンを押してください。
            </p>
          </form>
        </CommonModal.Body>
        <CommonModal.Footer>
          <Button onClick={hideModal} className="u-mr20">
            キャンセル
          </Button>
          <FormSubmitBtn text="作成する" {...{ submitting, submit: createClick }} />
        </CommonModal.Footer>
      </React.Fragment>
    </CommonModal>
  );
};

export default PdfCreateModal;
